export default "__VITE_ASSET__CHOm4Egv__"